import { TOrganizer } from "components/organizer/helpers/organizer-types-helper";
import { TSupplier } from "components/supplier/helpers/supplier-types-helper";

export const enum EExhibitionStatus
{
    ACTIVE = "active",
    CLOSED = "closed",
}

export const enum EExhibitionImportTemplate
{
    ALL_IN = "all_in",
    FMB = "fmb",
    AAA = "aaa",
}

export type TExhibitionType = {
    id: string;
    import_template: EExhibitionImportTemplate;
    title: string;
    organizer_id: string;
    total_stands: number;
    total_equipment: number;
    total_floorings: number;
    default: boolean;
    status: EExhibitionStatus;
    suppliers: TSupplier[];
    organizer: TOrganizer;
};

export interface IFilter {
    column: string;
    operator: string;
    value: string[];
    AND?: IFilter[];
}
